import React from 'react';

export default () => (
    <svg width="16" height="17" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.4167 2.08398H1.58333C1.26133 2.08398 1 2.34473 1 2.66732V4.41732C1 4.7399 1.26133 5.00065 1.58333 5.00065H14.4167C14.7387 5.00065 15 4.7399 15 4.41732V2.66732C15 2.34473 14.7387 2.08398 14.4167 2.08398Z"/>
        <path d="M13.8327 6.16797H9.74935V10.8346L7.99935 9.66797L6.24935 10.8346V6.16797H2.16602V14.3346C2.16602 14.6566 2.42735 14.918 2.74935 14.918H13.2493C13.5714 14.918 13.8327 14.6566 13.8327 14.3346V6.16797Z"/>
    </svg>
);
